;(function ($, hotspots, undefined) {
  "use strict";

  var Leaflet = L.noConflict();

  var ua = window.navigator.userAgent,
    isiOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i),
    isWebkit = !!ua.match(/WebKit/i),
    isWebkitiOS = isiOS && isWebkit,
    isMobileSafari = isiOS && isWebkit && !ua.match(/CriOS/i),
    getBrowserVersion = function(){
      var temp,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((temp = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, temp[1]);
      }
      return parseInt(M[1]);
    }

  // Store all the leaflets on the page in an array for access later
  var leaflets = [];

  // Store all image maps on the page in an object for access later
  var imageMaps = {};

  // Store all the more info area hotspots in an object for access later
  hotspots.infoSpots = {};

  var mapSetup = function(){
    $('.da-error').hide();
    $('.hotspot-info').addClass('da-hidden');

    var images = $('img.hotspots-image, picture.hotspots-image img'); // Select images as well as images inside picture elements

    images.each(function(){
      var img = $(this);

      var tester = new Image();

      tester.onload = function(){
        markLoaded(img);
        leafletSetup(img);
      };
      tester.src = img.attr('src');
    });

    if (isMobileSafari) {
      window.onpageshow = function(event){
        if (event.persisted) {
          window.location.reload();
        }
      };
    }
  };

  var markLoaded = function(img) {
    img.data('status', 'loaded');
    img.parents('.hotspots-container').addClass('loaded');
    img.attr('aria-hidden', true);
  };

  var showTooltip = function(shape, areaData) {
    if (areaData.href == '#') {
      return;
    }
    var container = $(shape._map._container);
    var content = $(areaData.href).html();

    var tip = Leaflet.responsivePopup({
      autoPan: false,
      closeButton: true,
      hasTip: container.width() > 840,
      maxHeight: container.height() * .9,
      offset: new Leaflet.Point(17, 12)
    });

    tip.setContent(content);
    shape.bindPopup(tip);
  };

  var leafletSetup = function(img) {
    var id = img.data('id');
    var container = $('<div id="hotspots-map-container-' + id + '" class="hotspots-map-container"></div>');
    var imgWidth = img.width();
    var imgHeight = img.height();

    container.css({
      'width': imgWidth + 'px',
      'height': imgHeight + 'px'
    });
    img.after(container);

    // Check to be sure the container is on the page
    // To prevent errors when loaded in Elementor popup
    var containerTest = $('#hotspots-map-container-' + id);
    if (!containerTest.length) {
      return
    }

    var map = Leaflet.map('hotspots-map-container-' + id, {
      attributionControl: false,
      boxZoom: false,
      crs: Leaflet.CRS.Simple,
      doubleClickZoom: false,
      dragging: false,
      keyboard: false,
      minZoom: -20,
      scrollWheelZoom: false,
      // tap: !isWebkitiOS,
      tap: true,
      touchZoom: false,
      zoomControl: false,
      zoomSnap: 0,
    });

    var domImg = img.get(0);
    var natHeight = domImg.naturalHeight;
    var natWidth = domImg.naturalWidth;
    img.data('natW', natWidth);
    img.data('natH', natHeight);
    var bounds = [[0,0], [natHeight, natWidth]];
    var imageLayer = Leaflet.imageOverlay(img.attr('src'), bounds).addTo(map);
    map.fitBounds(bounds);

    leaflets.push({
      map: map,
      img: img
    });

    drawSpots(img, map);
  };

  var drawSpots = function(img, map) {
    var id = img.data('id');

    /* If the image has a usemap attribute, detach the map and store it in the imageMaps object */
    if (img[0].hasAttribute('usemap')) {
      var mapName = img.attr('usemap').replace('#', '');
      var imageMap = $('map[name="' + mapName + '"]');
      imageMaps[id] = imageMap.detach();
      img.removeAttr('usemap');
    } else { /* Else we've already removed the image map, so we just need to get it */
      var imageMap = imageMaps[id];
    }

    var areas = imageMap.find('area');

    areas.each(function(){
      var area = $(this);
      var coords = area.attr('coords').split(',');
      var areaData = {
        style: area.data('color-scheme') ? area.data('color-scheme') : 'default',
        href: area.attr('href'),
      };

      renderIcon(coords, map, img, areaData);
    });

    // A11y fixes after all the spots are drawn
    a11yFixes(img, map);

    // Link to area after all the spots are drawn
    hotspots.linkToArea();
  };

  var renderIcon = function(coords, map, img, areaData) {
    var x = coords[0];
    var y = img.data('natH') - coords[1];

    var icon = Leaflet.icon({
      iconUrl: '/app/themes/default/assets/images/vendor/map-' + areaData.style + '.png',
      iconRetinaUrl: '/app/themes/default/assets/images/vendor/map-' + areaData.style + '@2x.png',
      iconSize:    [34, 34],
      iconAnchor:  [17, 17]
    });

    var marker = Leaflet.marker([y, x], {icon: icon});
    marker.addTo(map);
    Leaflet.DomUtil.addClass(marker._icon, 'map-' + areaData.style);

    // If this is a more info hotspot, add it to the infoSpots object
    if (areaData.href.charAt(0) === '#') {
      var spotName = areaData.href.replace('#', '');
      hotspots.infoSpots[spotName] = marker;
    }

    shapeEvents(marker, areaData);
  };

  var shapeEvents = function(shape, areaData) {
    // Handle tooltip spots
    showTooltip(shape, areaData);

    // Handle all other spots
    var moved = false;

    shape.on('touchstart touchmove touchend click mouseover mouseout keypress focus blur', function(e){
      switch(e.type) {
        case 'touchstart':
          moved = false;
          break;
        case 'touchmove':
          moved = true;
          break;
        case 'touchend':
          if (moved) {
            return;
          }
          // shapeClick(shape, areaData, e);
          break;
        case 'click':
          // shapeClick(shape, areaData, e);
          break;
        case 'keypress':
          var key = e.originalEvent.which;
          if ( key == 13 || key == 32) {
            e.originalEvent.preventDefault();
            // shapeClick(shape, areaData, e);
          }
          break;
        case 'mouseover':
          if (isMobileSafari && !(getBrowserVersion() >= 12)) {
            // shapeClick(shape, areaData, e);
          }
          break;
      }
    });
  };

  var a11yFixes = function(img, map){
    let svg = img.siblings('.leaflet-container').find('.leaflet-overlay-pane svg');
    let id = img.data('id');

    // Add title and description to SVG
    svg.prepend('<desc id="img-desc-' + id + '">' + img.data('image-description') + '</desc>');
    svg.prepend('<title id="img-title-' + id + '">' + img.data('image-title') + '</title>');

    // Use title and desc to describe the svg
    svg.attr('aria-labelledby', 'img-title-' + id);
    svg.attr('aria-describedby', 'img-desc-' + id);

    // Make svg screen reader traversable
    svg.attr('role', 'group');

    // Create a traversable list
    var group = svg.find('g').attr('role', 'list');
    group.children().attr('role', 'listitem');

    // Handle tooltips for the map
    map.on('popupopen',function(e) {
      // shift focus to the popup when it opens
      $(e.popup._container).find('.leaflet-rrose-content').attr('tabindex','-1').focus();

      // move the close button to the end of the popup content so screen readers reach it
      // after the main popup content, not before
      var close = $(e.popup._container).find('.leaflet-rrose-close-button').detach();
      close.attr('aria-label','Close item');
      $(e.popup._container).append(close);
    });

    $(document).on('click', function(e){
      map.closePopup();
    });

    $(document).on('keydown', function(e){
      if (e.which == 27) {
        map.closePopup();
      }
    });

    map.on('popupopen',function(e) {
      $(e.popup._source._icon).addClass('hotspot-active');
    });

    // return focus to the icon we started from before opening the pop up
    map.on('popupclose',function(e) {
      $(e.popup._source._icon).removeClass('hotspot-active').focus();
    });

    $(map._container).on('click', function(e){
      e.stopPropagation();
    });
  };

  hotspots.linkToArea = function(){ // Called after the shapes are drawn
    var hash = window.location.hash;
    if (!hash) return;

    var spotName = hash.replace('#', '');
    if (!hotspots.infoSpots.hasOwnProperty(spotName)) return;

    Object.keys(hotspots.infoSpots).forEach(function(key) {
      hotspots.infoSpots[key].closeTooltip()
    })

    hotspots.infoSpots[spotName].fire('click')
  };

  hotspots.setup = function(){
    mapSetup();
  };

  hotspots.resizeTimer = null;
  hotspots.resizing = false;

  hotspots.init = function(){ // For backward compatibility - resets the size of the leaflet on demand
    leaflets.forEach(function(item){
      var isLoaded = item.img.data('status') === 'loaded';

      if (!isLoaded) {
        return;
      }

      item.img.next('.hotspots-map-container').css({
        'width': item.img.width() + 'px',
        'height': item.img.height() + 'px'
      });
      item.map.invalidateSize(true);
      item.map.fitBounds([[0,0], [item.img.data('natH'), item.img.data('natW')]]);
    });
  };

}(jQuery, window.hotspots = window.hotspots || {}));

jQuery(function(){
  hotspots.setup();
});

jQuery(window).on('resize orientationchange', function(e){
  var $window = jQuery(this);
  if (!hotspots.resizing) {
    $window.trigger('resizeStart.responsilight');
    hotspots.resizing = true;
  }
  clearTimeout(hotspots.resizeTimer);
  hotspots.resizeTimer = setTimeout(function(){
    hotspots.init();
    $window.trigger('resizeComplete.responsilight');
    hotspots.resizing = false;
  }, 250);
});

jQuery(window).on('hashchange', function(){
  hotspots.linkToArea();
});

window.onerror = function(errorMsg, url, lineNumber) { // This should be a fun little experiement!
  var errorBox = jQuery('.da-error').show();
  if (errorBox.length) {
    var contents = errorBox.html();
    errorBox.html(contents + '<br/><br/><strong>Error:</strong> ' + errorMsg + '<br/>Line ' + lineNumber + ': ' + url);
  }
  return false;
}
